module.exports = __webpack_public_path__ + "img/t1-3.77e14c28.svg";